import { Injectable } from '@angular/core';
import { ProductInstanceModel } from '@shared/models/data/product-instance-model';
import { RemoveSeatsModel } from '@shared/models/data/remove-seats-model';
import { ResidentModel } from '@shared/models/data/resident-model';
import { SaveSeatModel } from '@shared/models/data/save-seat-model';
import { SaveSeatsModel } from '@shared/models/data/save-seats-model';
import { SeatAssignmentModel } from '@shared/models/data/seat-assignment-model';
import { SeatModel } from '@shared/models/data/seat-model.component';
import { forEachChild } from 'typescript';

@Injectable({
  providedIn: 'root'
})
export class SeatAssignmentService {

  constructor() { }

  public getPaidSeats(residents: SeatAssignmentModel[]) {
    residents = residents.filter(resident => resident.purchased = false);
    return residents;
  }

  public getWishList(residents: SeatAssignmentModel[]) {
    residents = residents.filter(resident => resident.purchased = true);
    return residents;
  }

  public residentsToSaveSeatsModel(residents: Array<ResidentModel>, productId: string) {
    const saveSeats: SaveSeatsModel = {seatModels: new Array<SeatModel>()};
    residents.forEach(element => {
      saveSeats.seatModels.push({
        residentId: element.id,
        institutionId: element.institutionId,
        productId: productId
      });
    });
    return saveSeats;
  }

  public residentsToRemoveSeatsModel(residents: Array<ResidentModel>, productId: string) {
    const removeSeats: RemoveSeatsModel = {seatModels: new Array<SeatModel>()};
    residents.forEach(element => {
      removeSeats.seatModels.push({
        residentId: element.id,
        institutionId: element.institutionId,
        productId: productId
      });
    });
    return removeSeats;
  }
}
